import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03 9.067a.1.1 0 000 .141l.717.712a.1.1 0 00.142 0l3.086-3.066L9.112 9.97a.1.1 0 00.142 0l.716-.712a.1.1 0 000-.14L6.833 6 9.97 2.882a.1.1 0 000-.14l-.716-.713a.1.1 0 00-.142 0L5.975 5.148 2.888 2.081a.1.1 0 00-.142 0l-.717.712a.1.1 0 000 .14l3.087 3.068-3.085 3.066z"
  })));
}

export { SvgClose as ReactComponent };
